var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 3.33398V4.50065C3.3335 7.30091 3.3335 8.70104 3.87846 9.7706C4.35783 10.7114 5.12273 11.4763 6.06354 11.9557C7.1331 12.5007 8.53323 12.5007 11.3335 12.5007H16.6668M16.6668 12.5007L12.5002 8.33398M16.6668 12.5007L12.5002 16.6673",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideChat);
export default __webpack_public_path__ + "static/media/side-chat.0b28e6888b3845d07f4718db251d3937.svg";
export { ForwardRef as ReactComponent };